module.exports = __webpack_public_path__ + "static/img/2900_phase_function_Paper_Points.2f4d0d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2900_phase_function_Paper_Points.png
// module id = c4p0
// module chunks = 0